import { createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';
import { persistStore, persistReducer } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import { apiMiddleware } from 'redux-api-middleware';
import { createLogger } from 'redux-logger';
import { USER_LOGOUT_SUCCESS } from './ducks/auth';
import apiErrorMiddleware from './apiErrorMiddleware';

import appReducer from './ducks/allReducers';

const rootReducer = (state, action) => {
  return appReducer(action.type === USER_LOGOUT_SUCCESS ? undefined : state, action);
  // TODO: clearing navigation stack would be a good thing here too.
  // In fact, just doing a full page refresh would take care of it as well.
};

const persistConfig = {
  key: 'root',
  storage,
  whitelist: ['auth'],
};

const persistedReducer = persistReducer(persistConfig, rootReducer);

let middleware = [thunk, apiMiddleware, apiErrorMiddleware];

if (process.env.NODE_ENV === 'development') {
  middleware = [...middleware, createLogger({ collapsed: true })];
}

// eslint-disable-next-line no-underscore-dangle
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;
const store = createStore(persistedReducer, composeEnhancers(applyMiddleware(...middleware)));
export const persistor = persistStore(store);

export default store;



// WEBPACK FOOTER //
// ./src/redux/store.js